import React, { useEffect } from 'react';
import { ApmContext } from '../context';
import { useInitializeApmInstance, useInitializeApmUserContext } from '../hooks';
let apmGlobalInstance = null;
export const getGlobalApmInstance = ()=>apmGlobalInstance;
const ApmProvider = ({ children, onReady, userLoginSelector })=>{
    const apm = useInitializeApmInstance(onReady);
    useEffect(()=>{
        apmGlobalInstance = apm;
        return ()=>{
            apmGlobalInstance = null;
        };
    }, [
        apm
    ]);
    useInitializeApmUserContext(apm, userLoginSelector);
    return /*#__PURE__*/ React.createElement(ApmContext.Provider, {
        value: apm
    }, children);
};
export default ApmProvider;
